module.exports = __webpack_public_path__ + "media/images/careers/health-34d236f5c3fcc9ae705d1a74d6d677a1.svg";